module.exports = __webpack_public_path__ + "img/new_technology.8cb77302.svg";